import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button onClick={() => navigate(-1)} variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </Button>
          <h1 className="font-bold text-xl">Politique de Confidentialité</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm p-8 prose prose-slate max-w-none">
          <p className="text-gray-500 mb-8">Dernière mise à jour : 11 mars 2026</p>

          <h2>1. Introduction</h2>
          <p>
            MPHONE ("nous", "notre", "nos") exploite l'application CAISSE MPHONE (le "Service"). 
            Cette page vous informe de nos politiques concernant la collecte, l'utilisation et 
            la divulgation des données personnelles lorsque vous utilisez notre Service.
          </p>

          <h2>2. Données collectées</h2>
          <p>Nous collectons plusieurs types de données pour fournir et améliorer notre Service :</p>
          
          <h3>2.1 Données personnelles</h3>
          <ul>
            <li>Adresse email</li>
            <li>Nom complet</li>
            <li>Numéro de téléphone</li>
            <li>Adresse postale (pour la facturation)</li>
          </ul>

          <h3>2.2 Données d'utilisation</h3>
          <ul>
            <li>Informations sur les transactions (encaissements, factures)</li>
            <li>Données de connexion (date, heure, durée)</li>
            <li>Préférences utilisateur</li>
          </ul>

          <h3>2.3 Données Google Business Profile</h3>
          <p>
            Si vous connectez votre compte Google Business, nous accédons aux données suivantes 
            avec votre autorisation explicite :
          </p>
          <ul>
            <li>Informations de votre établissement (nom, adresse, horaires)</li>
            <li>Avis clients et réponses</li>
            <li>Publications sur votre fiche Google</li>
            <li>Statistiques de visibilité</li>
          </ul>
          <p>
            Ces données sont utilisées uniquement pour vous permettre de gérer votre fiche 
            Google Business directement depuis notre application. Nous ne partageons pas 
            ces données avec des tiers.
          </p>

          <h2>3. Utilisation des données</h2>
          <p>MPHONE utilise les données collectées pour :</p>
          <ul>
            <li>Fournir et maintenir le Service</li>
            <li>Vous notifier des changements apportés à notre Service</li>
            <li>Permettre la gestion de votre comptabilité et facturation</li>
            <li>Gérer votre fiche Google Business Profile</li>
            <li>Générer des réponses aux avis clients via intelligence artificielle</li>
            <li>Fournir un support client</li>
            <li>Détecter, prévenir et résoudre les problèmes techniques</li>
          </ul>

          <h2>4. Conservation des données</h2>
          <p>
            Nous conservons vos données personnelles uniquement pendant la durée nécessaire 
            aux fins énoncées dans cette politique. Les données comptables sont conservées 
            conformément aux obligations légales françaises (10 ans pour les documents comptables).
          </p>

          <h2>5. Sécurité des données</h2>
          <p>
            La sécurité de vos données est importante pour nous. Nous utilisons des mesures 
            de sécurité conformes aux standards de l'industrie :
          </p>
          <ul>
            <li>Chiffrement des données en transit (HTTPS/TLS)</li>
            <li>Authentification à deux facteurs (2FA)</li>
            <li>Stockage sécurisé des mots de passe (hachage bcrypt)</li>
            <li>Accès restreint aux données personnelles</li>
          </ul>

          <h2>6. Vos droits (RGPD)</h2>
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous avez le droit de :</p>
          <ul>
            <li><strong>Accès</strong> : Demander une copie de vos données personnelles</li>
            <li><strong>Rectification</strong> : Corriger des données inexactes</li>
            <li><strong>Effacement</strong> : Demander la suppression de vos données</li>
            <li><strong>Limitation</strong> : Restreindre le traitement de vos données</li>
            <li><strong>Portabilité</strong> : Recevoir vos données dans un format structuré</li>
            <li><strong>Opposition</strong> : Vous opposer au traitement de vos données</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à : <strong>kophonelab@gmail.com</strong>
          </p>

          <h2>7. Services tiers</h2>
          <p>Notre Service utilise des services tiers qui peuvent collecter des données :</p>
          <ul>
            <li><strong>Google</strong> : Pour l'intégration Google Business Profile</li>
            <li><strong>Twilio</strong> : Pour l'envoi de SMS (authentification 2FA)</li>
            <li><strong>Resend</strong> : Pour l'envoi d'emails</li>
            <li><strong>OpenAI</strong> : Pour la génération de réponses IA aux avis</li>
          </ul>

          <h2>8. Cookies</h2>
          <p>
            Nous utilisons des cookies et des technologies similaires pour maintenir votre 
            session de connexion et mémoriser vos préférences. Vous pouvez configurer votre 
            navigateur pour refuser les cookies, mais certaines fonctionnalités du Service 
            pourraient ne pas fonctionner correctement.
          </p>

          <h2>9. Modifications</h2>
          <p>
            Nous pouvons mettre à jour notre Politique de Confidentialité de temps en temps. 
            Nous vous informerons de tout changement en publiant la nouvelle politique sur 
            cette page et en mettant à jour la date de "Dernière mise à jour".
          </p>

          <h2>10. Contact</h2>
          <p>Pour toute question concernant cette Politique de Confidentialité, contactez-nous :</p>
          <ul>
            <li><strong>Email</strong> : kophonelab@gmail.com</li>
            <li><strong>Adresse</strong> : 5 Rue Paul Verlaine, 69100 Villeurbanne, France</li>
            <li><strong>Téléphone</strong> : 04 78 XX XX XX</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
